function SignalIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M20.7359 5.41653C22.724 7.43957 23.8365 10.1635 23.8332 12.9999C23.8349 14.421 23.5562 15.8284 23.013 17.1416C22.4698 18.4548 21.6728 19.6479 20.6677 20.6525M5.41651 20.737C4.38597 19.7294 3.5675 18.5258 3.00934 17.197C2.45118 15.8682 2.16461 14.4411 2.16651 12.9999C2.16475 11.5751 2.44488 10.1642 2.99076 8.84817C3.53664 7.53218 4.33749 6.33719 5.34718 5.33203"
        stroke="#0D4AF9"
        stroke-width="2.125"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.7"
        d="M17.6416 8.71441C18.7899 9.814 19.4995 11.3198 19.4995 12.9806C19.4995 14.6619 18.7737 16.184 17.6004 17.2857M8.44951 17.3334C7.24701 16.2273 6.49951 14.6857 6.49951 12.9806C6.49951 11.296 7.2286 9.76958 8.40835 8.66675"
        stroke="#0D4AF9"
        stroke-width="2.125"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.9997 15.1666C14.1963 15.1666 15.1663 14.1965 15.1663 12.9999C15.1663 11.8033 14.1963 10.8333 12.9997 10.8333C11.8031 10.8333 10.833 11.8033 10.833 12.9999C10.833 14.1965 11.8031 15.1666 12.9997 15.1666Z"
        stroke="#0D4AF9"
        stroke-width="2.125"
      />
    </svg>
  );
}

export default SignalIcon;
